<!--Do NOT change this file manually, it is being generated by 'fws icons' command.-->

<template>
    <component v-bind:is="component"/>
</template>

<script>
    import startcase from 'lodash.startcase';
    import ArrLeft from '../../../../assets/svg/ico-arr-left.svg';
    import ArrRightSlim from '../../../../assets/svg/ico-arr-right-slim.svg';
    import ArrRight from '../../../../assets/svg/ico-arr-right.svg';
    import ArrowDown from '../../../../assets/svg/ico-arrow-down.svg';
    import ArrowLeft from '../../../../assets/svg/ico-arrow-left.svg';
    import ArrowRight from '../../../../assets/svg/ico-arrow-right.svg';
    import ArrowUp from '../../../../assets/svg/ico-arrow-up.svg';
    import Bookmark from '../../../../assets/svg/ico-bookmark.svg';
    import Check from '../../../../assets/svg/ico-check.svg';
    import ChevronDownLight from '../../../../assets/svg/ico-chevron-down-light.svg';
    import ChevronDown from '../../../../assets/svg/ico-chevron-down.svg';
    import Close from '../../../../assets/svg/ico-close.svg';
    import Dog from '../../../../assets/svg/ico-dog.svg';
    import EnvelopeFull from '../../../../assets/svg/ico-envelope-full.svg';
    import Facebook from '../../../../assets/svg/ico-facebook.svg';
    import Fax from '../../../../assets/svg/ico-fax.svg';
    import GooglePlus from '../../../../assets/svg/ico-google-plus.svg';
    import Happy from '../../../../assets/svg/ico-happy.svg';
    import Instagram from '../../../../assets/svg/ico-instagram.svg';
    import Linkedin from '../../../../assets/svg/ico-linkedin.svg';
    import Lock from '../../../../assets/svg/ico-lock.svg';
    import Mail from '../../../../assets/svg/ico-mail.svg';
    import Paperclip from '../../../../assets/svg/ico-paperclip.svg';
    import PhoneFull from '../../../../assets/svg/ico-phone-full.svg';
    import Phone from '../../../../assets/svg/ico-phone.svg';
    import Pin from '../../../../assets/svg/ico-pin.svg';
    import Play from '../../../../assets/svg/ico-play.svg';
    import PlusCircle from '../../../../assets/svg/ico-plus-circle.svg';
    import Plus from '../../../../assets/svg/ico-plus.svg';
    import Search from '../../../../assets/svg/ico-search.svg';
    import Twitter from '../../../../assets/svg/ico-twitter.svg';
    import User from '../../../../assets/svg/ico-user.svg';

    export default {
        props: {
            iconName: {
                type: String,
                required: true
            }
        },
        components: {
            ArrLeft,
            ArrRightSlim,
            ArrRight,
            ArrowDown,
            ArrowLeft,
            ArrowRight,
            ArrowUp,
            Bookmark,
            Check,
            ChevronDownLight,
            ChevronDown,
            Close,
            Dog,
            EnvelopeFull,
            Facebook,
            Fax,
            GooglePlus,
            Happy,
            Instagram,
            Linkedin,
            Lock,
            Mail,
            Paperclip,
            PhoneFull,
            Phone,
            Pin,
            Play,
            PlusCircle,
            Plus,
            Search,
            Twitter,
            User,

        },
        computed: {
            component() {
                return startcase(this.iconName.replace('ico-', '')).replace(' ', '');
            }
        }
    };
</script>
